import { render, staticRenderFns } from "./PanelMarketItemRequireConfig.vue?vue&type=template&id=4161e1c6&scoped=true&"
import script from "./PanelMarketItemRequireConfig.vue?vue&type=script&lang=js&"
export * from "./PanelMarketItemRequireConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4161e1c6",
  null
  
)

export default component.exports